(function($, document) {
    'use strict';

    function ElementsStack() {
        this.stack = [];
    }

    ElementsStack.prototype = {
        push: function($element) {
            var
                self = this,
                found = false;

            this.forEach(function(index, element) {
                if( self.areEquals(element, $element) ) {
                    found = true;
                }
            });

            if( ! found) {
                this.stack.push($element);
            }
        },

        getIdentifier: function($element) {
            var id = $element.data('stack-identifier');

            if(id === undefined) {
                var timestamp = (new Date()).getTime();
                id = 'stack-id-prefix-' + timestamp;

                $element.data('stack-identifier', id);
            }

            return id;
        },

        areEquals: function($elementA, $elementB) {
            return this.getIdentifier($elementA) === this.getIdentifier($elementB);
        },

        forEach: function(callback) {
            $.each(this.stack, callback);
        },

        clear: function() {
            this.stack = [];
        }
    };

    var
        elementsStack = new ElementsStack(),
        $document = $(document),
        continueLoader = false;

    $document.on('click', 'a, button', function() {
        var
            $this = $(this),
            $loader = $this.find('> .button-loader');

        if( $loader.length && ! $loader.hasClass('hidden') ) {
            return false;
        }

        if ($loader.length) {
            $this.addClass('disabled-event');
            $loader.siblings().addClass('not-visible');
            $loader.removeClass('hidden');

            elementsStack.push($loader);
        }
    });

    $document.on('loader.finish', function() {
        elementsStack.forEach(function (index, $loader) {
            var $checkAnimate = $loader.siblings('.check-animate');

            $loader.addClass('hidden').parent().removeClass('disabled-event');

            if( $checkAnimate.length ) {
                $checkAnimate.removeClass('hidden not-visible');

                setTimeout(function() {
                    $loader.siblings().removeClass('hidden not-visible');
                    $checkAnimate.addClass('hidden');
                }, 2000);
            }
            else {
                $loader.siblings().removeClass('hidden not-visible');
            }

        });

        elementsStack.clear();
    });

    $document.on('loader.continue', function() {
        continueLoader = true;
    });

    $document.on('loader.stop', function() {
        continueLoader = false;
    });

    $document.ajaxStart(function (e) {
        $(e.currentTarget.activeElement).each(function () {
            var
                $loader = $(this).find('> .button-loader');

            if ($loader.length) {
                $loader.siblings().addClass('not-visible');
                $loader.removeClass('hidden');

                elementsStack.push($loader);
            }
        });

    });

    $document.ajaxStop(function () {
        if(continueLoader === false) {
            $document.trigger('loader.finish');
        }
    });

})(jQuery, document);
